"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Embed extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Grabs metadata and returns metadata for the given url such as title, description and thumbnails.
     * @param attributes
     * @returns
     */
    create(attributes) {
        const requestObj = {
            method: 'post',
            url: `/embed/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Embed;
